module.exports = __webpack_public_path__ + "static/media/knows2.633dec68.wav";


//////////////////
// WEBPACK FOOTER
// ./src/components/Monsters/knows2.wav
// module id = 217
// module chunks = 0